import React from "react";
import { connect } from "react-redux";
import { fnToSlash, fnMoneda } from "../tools";
import { consultarRecibos } from "./polizas.act";
import { descargarDocumento } from "./polizas.act";

const mapState = (state) => {
	return {
		"poliza": state.polizas.poliza,
		"recibos": state.polizas.recibos

	};
};

const mapDispatch = (dispatch) => {
	return {
		consultarRecibos: (sPoliza, fIni, fFin) => {
			dispatch({ "type": "RECIBOS_LIMPIAR" });
			dispatch(consultarRecibos(sPoliza, fIni, fFin));
		},
		descargarDocumento: (sDocumento, sPoliza, sVersion, sRecibo) => {
			dispatch(descargarDocumento(sDocumento, sPoliza, sVersion, sRecibo));
		}

	};
};

class DescargaRecibos extends React.Component {
	state = {
		"paginas": [],
		"currentPage": 0,
		"currentMetaPage": 0
	}

	componentWillMount = () => {
		this.props.consultarRecibos(this.props.poliza.generales.numPoliza, this.props.poliza.generales.fchVigenciaInicial, this.props.poliza.generales.fchVigenciaFinal);
	}
	
	calcularPaginas = () => {
		var numPaginas = 0;

		if (this.props.recibos) {
			numPaginas = Math.ceil(this.props.recibos.length / 6);
		}

		var paginas = [];
		for (var i = 0; i < numPaginas; i++) {
			paginas.push("");
		}
		return paginas;
	}
	
	goToPage = (i) => {
		this.setState({
			"currentPage": i
		});
	}

	changeMeta = (change) => {
		var currentMetaPage = this.state.currentMetaPage + change;
		this.setState({
			"currentMetaPage": currentMetaPage
		});
	}

	descargar = (sRecibo) => {
		this.props.descargarDocumento("recibo", this.props.poliza.generales.numPoliza, this.props.poliza.generales.numVersion, sRecibo);
	}

	render() {
		return <div className="mt-34">
			<h5 className="pd-lr-30">Recibos
				<button type="button" className="close pull-right" data-dismiss="modal" aria-label="Close"><img src={ require("../img/x.svg") } alt="" /></button>
			</h5>
			<hr className="mt-34" />
			<div className="row">
				<div className="col-xs-12 col-md-10 col-md-offset-1">
					<p className="text-center">En esta sección podrás visualizar los recibos asociados  a tu póliza en formato pdf. Haz clic en el icono de descarga para guardar o imprimir.</p>
					<div className="row">
						<div className="col-sm-12">
							<table className="table table-striped table-center mt-34 tabla-recibos">
								<thead>
									<tr>
										<th><span className="hide-mobile">Número de recibo</span><span className="show-mobile">Número</span></th>
										<th>Estatus</th>
										<th className="hide-mobile">Fracción</th>
										<th><span className="hide-mobile">Periodo que cubre</span><span className="show-mobile">Periodo</span></th>
										<th><span className="hide-mobile">Importe del recibo</span><span className="show-mobile">Importe</span></th>
										<th className="hide-mobile">Moneda</th>
										<th></th>
									</tr>
								</thead>
								<tbody>
									{ this.props.recibos && this.props.recibos.map((recibo, i)=>
										<tr key={i} className={Math.floor(i / 6) == this.state.currentPage ? "show-tr" : "hide"}>
											<td>{recibo.codNumRecibo}</td>
											<td>{recibo.descripEstadoRecibo}</td>
											<td className="hide-mobile">{recibo.numFraccion}</td>
											<td>{ fnToSlash(recibo.fechaEfecRec) } - { fnToSlash(recibo.fechaVencRec) }</td>
											<td>$ { fnMoneda(recibo.impTotalRecibo) }</td>
											<td className="hide-mobile">{recibo.cveCodMoneda}</td>
											<td><img style={{"cursor":"pointer"}} onClick={this.descargar.bind(this, recibo.codNumRecibo)} src={ require("../img/icon-dowload.svg") } /></td>
										</tr>
									)}
								</tbody>
							</table>
							<div className="text-center paginador mt-50">
								<ul className="clearfix">
									<li className={this.state.currentPage > 6 ? "show-li" : "hide"}>
										<a onClick={this.changeMeta.bind(this, -1)}>
											<img src={ require("../img/flecha-izquierda.svg") } />
										</a>
									</li>
									{ this.calcularPaginas().map((item, i) =>
										<li key={i} className={Math.ceil(i / 6) == this.state.currentMetaPage}>
											<a className={this.state.currentPage == i ? "orange-text" : ""} onClick={this.goToPage.bind(this, i)}>{i + 1}</a>
										</li>
									)}
									<li className={this.calcularPaginas() > 6 ? "show-li" : "hide"}>
										<a onClick={this.changeMeta.bind(this, 1)}>
											<img src={ require("../img/flecha-abajo.svg") } />
										</a>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>;
	}
}

export default connect(mapState, mapDispatch)(DescargaRecibos);



// WEBPACK FOOTER //
// ./src/home/descargaRecibos.cmpt.js